import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        sorting: null
    },
    getters: {
        sorting: (state) => (defaultValue) => {
            if(state.sorting !== null) {
                return state.sorting;
            }
            try {
                state.sorting = JSON.parse(Vue.localStorage.get('sorting'));
                return state.sorting !== null ? state.sorting : defaultValue;
            } catch (e) {
                return defaultValue;
            }
        }
    },
    actions: {

    },
    mutations: {
        sorting (state, sorting) {
            state.sorting = sorting;
            Vue.localStorage.set('sorting', JSON.stringify(sorting));
        }
    }
}